/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VIPProfile } from './VIPProfile';
import {
    VIPProfileFromJSON,
    VIPProfileFromJSONTyped,
    VIPProfileToJSON,
    VIPProfileToJSONTyped,
} from './VIPProfile';

/**
 * 
 * @export
 * @interface PaginatedVIPProfileList
 */
export interface PaginatedVIPProfileList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedVIPProfileList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedVIPProfileList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedVIPProfileList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<VIPProfile>}
     * @memberof PaginatedVIPProfileList
     */
    results: Array<VIPProfile>;
}

/**
 * Check if a given object implements the PaginatedVIPProfileList interface.
 */
export function instanceOfPaginatedVIPProfileList(value: object): value is PaginatedVIPProfileList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedVIPProfileListFromJSON(json: any): PaginatedVIPProfileList {
    return PaginatedVIPProfileListFromJSONTyped(json, false);
}

export function PaginatedVIPProfileListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedVIPProfileList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(VIPProfileFromJSON)),
    };
}

  export function PaginatedVIPProfileListToJSON(json: any): PaginatedVIPProfileList {
      return PaginatedVIPProfileListToJSONTyped(json, false);
  }

  export function PaginatedVIPProfileListToJSONTyped(value?: PaginatedVIPProfileList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(VIPProfileToJSON)),
    };
}

